import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');

  if (!token) return <Navigate to="/login" />;

  try {
    const decoded = jwtDecode(token);
    return decoded.admin ? children : <Navigate to="/dashboard" />;
  } catch (err) {
    console.error('Invalid token in AdminRoute:', err);
    return <Navigate to="/login" />;
  }
};

export default AdminRoute;